var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeGroupHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 202,
    viewBox: "0 0 43 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7463 1H11C5.47715 1 1 5.47715 1 11L1 74.2364M1 74.2364L1 173.322V181C1 192.046 9.95431 201 21 201H43M1 74.2364L9.94551 91.8822C13.3528 98.6034 20.2487 102.839 27.7842 102.839H42",
    stroke: "#12246c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeGroupHighlight);
export default __webpack_public_path__ + "static/media/three-group-highlight.acbb0ea0eb6de459fde26cff33870494.svg";
export { ForwardRef as ReactComponent };